<template>
    <form-accordion
        name="zoning"
        section="Zoning"
        :url="url"
        method="PATCH"
        :closed="closed"
        :read_only="read_only"
    >
        <zoning-change-index
            :commercial="property.commercial"
            :read_only="read_only"
        />

        <survey-index
            :commercial="property.commercial"
            :read_only="read_only"
        />

        <site-development-index
            :commercial="property.commercial"
            :read_only="read_only"
        />
    </form-accordion>
</template>

<script>
import ZoningChangeIndex from './zoning-change/zoning-change-index.vue';
import SurveyIndex from './survey/survey-index.vue';
import SiteDevelopmentIndex from './site-development/site-development-index.vue';

export default {
    components: {
        ZoningChangeIndex,
        SurveyIndex,
        SiteDevelopmentIndex,
    },

    props: {
        url: {},
        closed: { default: true },
        property: { default: () => ({}) },
        read_only: { default: false },
    },
}
</script>
